import { usePortal } from '../Portal';

/** The claim in one line: each item with the issue chosen for it. */
export function ClaimedPills() {
  const { config, t, state } = usePortal();
  const picked = state.view?.items.filter((item) => state.draft.items[item.id]) ?? [];
  if (picked.length === 0) return null;

  return (
    <p className="nvd-claim-portal__claiming">
      <span className="nvd-claim-portal__claiming-label">{t('issue.claimingLabel')}</span>
      {picked.map((item) => {
        const draft = state.draft.items[item.id];
        if (!draft) return null;
        const reason = config.reasons.find((candidate) => candidate.id === draft.reasonId);
        const detail = reason?.freeText && draft.note ? draft.note : (reason?.label ?? '');
        return (
          <span key={item.id} className="nvd-claim-portal__pill">
            <b>
              {item.title}
              {draft.quantity > 1 && ` × ${draft.quantity}`}
            </b>
            {detail && ` · ${detail}`}
          </span>
        );
      })}
    </p>
  );
}

/** The items in the claim with their quantities, so a confirm step shows exactly what it covers. */
export function ClaimedItems() {
  const { t, state } = usePortal();
  const picked = state.view?.items.filter((item) => state.draft.items[item.id]) ?? [];
  if (picked.length === 0) return null;

  return (
    <dl className="nvd-claim-portal__summary nvd-claim-portal__summary--items">
      <div className="nvd-claim-portal__summary-caption">{t('reorder.itemsLabel')}</div>
      {picked.map((item) => (
        <div key={item.id} className="nvd-claim-portal__summary-row">
          <dt>{item.title}</dt>
          <dd>× {state.draft.items[item.id]?.quantity}</dd>
        </div>
      ))}
    </dl>
  );
}
